import { useContext } from "react";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Button,
} from "@mui/material";
import { MdMenuOpen, MdOutlineMenu, MdLogout } from "react-icons/md";
import { MyContext } from "../../Home.js";
import Logoo from "../Images/logo.jpg";

const Navbar = () => {
  const iconColor = "#ffffff"; // Static icon color

  const handleLogout = () => {
    localStorage.removeItem("sessionToken");
    window.location.href = "/login"; // Adjust the path as needed
    console.log("User logged out and localStorage cleared");
  };

  // Toggle Sidebar visibility
  const context = useContext(MyContext);

  return (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "#333", // Static background color
          color: iconColor,
          boxShadow: "none",
          height: { xs: "60px", md: "70px" },
        }}
      >
        <Toolbar sx={{ padding: { xs: "0 10px", md: "0 20px" } }}>
          {/* Logo Section */}
          <Box
            component={Link}
            sx={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "inherit",
              marginRight: "auto",
            }}
          >
            {/* Logo */}
            <img
              src={Logoo}
              alt={"logo"}
              width={45}
              height={45}
              style={{ display: { xs: "none", sm: "block" } }}
            />

            {/* Dashboard Text */}
            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                marginLeft: 1,
                fontSize: { xs: "16px", sm: "20px" }, // Adjust font size for mobile
                display: { xs: "none", sm: "block" }, // Hide text on extra small screens
              }}
            >
              UK Admin Mars
            </Typography>

            {/* Menu Button */}
            <IconButton
              onClick={() =>
                context.setIsToggleSidebar(!context.isToggleSidebar)
              }
              sx={{
                marginLeft: { xs: 1, md: 6 },
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                borderRadius: 2,
                width: { xs: 40, md: 44 },
                height: { xs: 40, md: 44 },
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                  backgroundColor: "rgba(79, 195, 247, 0.2)",
                  transform: "translateY(-1px)",
                  boxShadow: "0 4px 12px rgba(79, 195, 247, 0.3)",
                },
                "&:active": {
                  transform: "translateY(0)",
                },
              }}
            >
              <Box
                sx={{
                  transition: "transform 0.3s ease",
                  transform: context.isToggleSidebar
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                }}
              >
                {context.isToggleSidebar ? (
                  <MdMenuOpen color={iconColor} size={22} />
                ) : (
                  <MdOutlineMenu color={iconColor} size={22} />
                )}
              </Box>
            </IconButton>
          </Box>

          {/* Right Section - Logout */}
          <Button
            onClick={handleLogout}
            startIcon={<MdLogout size={20} />}
            sx={{
              color: iconColor,
              textTransform: "none",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                display: { xs: "none", md: "block" }, // Hide text on small screens
              }}
            >
              Logout
            </Typography>
          </Button>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Navbar;
